module.exports = __webpack_public_path__ + "static/45import-9d656ea9d21501550deaa713104fb654.png";